



















import { Component, Vue } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'
import axios from '@/server-axios'
import * as moment from 'moment'
import Event from '@/models/event'
import { Actions } from '@/util/vuex-types'
import RateBreweryForm from '@/components/RateBreweryForm.vue'
import { RouteRecord, Route, RawLocation } from 'vue-router'
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
])

@Component({
    components: {
        'rate-brewery-form': RateBreweryForm,
    },
})
export default class AttendAnEvent extends Vue {
    code: string = ''
    eventFound: boolean = false
    destroyed: boolean = false
    error: string = ''
    event?: Event
    breweryRated = false
    @State currentEvents!: Event[]
    @Action [Actions.FETCH_EVENTS]: any

    async mounted() {
        if (this.currentEvents == null || this.currentEvents.length === 0) {
            await this.fetchEvents(await this.$auth.getAccessToken())
        }
    }

    formatDate(date: moment.Moment){
        return date.format('MMM DD, YYYY hh:mm A')
    }
}
